import { NgModule } from '@angular/core';
import { MultilingualPipe } from 'src/app/shared/core/pipes/multilingual-pipe';

@NgModule({
  imports: [],
  declarations: [MultilingualPipe],
  exports: [MultilingualPipe],
})

export class PipeModule {

  static forRoot() {
    return {
      ngModule: PipeModule,
      providers: [],
    };
  }
}
